var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "google-places px-6 md:px-16 pb-36" },
    [
      _c("div", { staticClass: "tabs" }, [
        _vm.places !== undefined
          ? _c(
              "div",
              { staticClass: "tabs" },
              _vm._l(_vm.places, function(place) {
                return _c(
                  "div",
                  {
                    key: place.id,
                    ref: "tabs",
                    refInFor: true,
                    staticClass: "tab",
                    on: {
                      click: function($event) {
                        return _vm.openModal(place)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "heading" }, [
                      _c("h2", [_vm._v(_vm._s(place.title))]),
                      _vm._v(" "),
                      place.details.length
                        ? _c("div", { staticClass: "details" }, [
                            _c("p", { staticClass: "subtitle" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(place.details[0].subtitle) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "eta" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(place.details[0].walkingEta) +
                                  "\n            "
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "indicator" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "14",
                            fill: "none"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "#29261E",
                              d: "M0 8V6h12L8 2l1-2 7 7-7 7-1-2 4-4H0z"
                            }
                          })
                        ]
                      )
                    ])
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("PlacesModal", {
        attrs: { modal: _vm.activeModal, places: _vm.places },
        on: { visiblePlace: _vm.openModal, modalClosed: _vm.openModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }